export enum OFFER_TYPE {
  SHIPPING_DISCOUNT = 'SHIPPING_DISCOUNT',
  TOTAL_DISCOUNT = 'TOTAL_DISCOUNT',
  PRODUCT_DISCOUNT = 'PRODUCT_DISCOUNT',
  INCLUDE_PRODUCT = 'INCLUDE_PRODUCT',
  TWO_FOR_ONE = 'TWO_FOR_ONE',
}

export enum DISCOUNT_TYPE {
  FREE = 'FREE',
  DISCOUNT = 'DISCOUNT',
}

export enum DISCOUNT_DISCOUNT_TYPE {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT',
}

export enum RULE_OFFER_FACT_TYPE {
  AMOUNT = 'AMOUNT',
  PRODUCT = 'PRODUCT',
  // CATEGORY = 'CATEGORY',
  ADDRESS = 'ADDRESS',
  USAGE = 'USAGE',
  QUANTITY_ORDERS = 'QUANTITY_ORDERS',
  CATEGORY_PRICE = 'CATEGORY_PRICE',

  // client
  ORDER_COUNT_BY_TIME = 'ORDER_COUNT_BY_TIME',
  AMOUNT_SPENT_BY_TIME = 'AMOUNT_SPENT_BY_TIME',
  LONGEVITY = 'LONGEVITY',
  SPECIFIC_CLIENT_LIST = 'SPECIFIC_LIST',
  CLIENT_USAGES = 'CLIENT_USAGES',
  LAST_PURCHASE_DATE = 'LAST_PURCHASE_DATE',
}

export enum OPERATOR_RULE_OFFER_TYPE {
  EQUAL = 'EQUAL',
  DISTINCT = 'DISTINCT',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN = 'GREATER_THAN',
  AT_LEAST_ONE = 'AT_LEAST_ONE',
  ALL = 'ALL',
}

export enum PERIOD_RULE_OFFER_TYPE {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  BIMESTER = 'BIMESTER',
  TRIMESTER = 'TRIMESTER',
  SEMESTER = 'SEMESTER',
  YEAR = 'YEAR',
  SINCE_CREATION = 'SINCE_CREATION',
}

export enum TWO_FOR_ONE_OPERATOR {
  EVERY = 'EVERY',
  MORE_THAN = 'MORE_THAN',
}

export const PERIOD = Object.keys(PERIOD_RULE_OFFER_TYPE) as PERIOD_RULE_OFFER_TYPE[];
